var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.visible ? _c('div', {
    staticClass: "absolute right-0 z-50 p-3 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg filter-popup top-full",
    attrs: {
      "data-filter-modal": ""
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-between mb-3"
  }, [_c('h3', {
    staticClass: "text-lg font-normal text-gray-500"
  }, [_vm._v("Filter")]), _c('button', {
    staticClass: "text-gray-400 hover:text-gray-600 focus:outline-none",
    on: {
      "click": _vm.onCancel
    }
  }, [_c('svg', {
    staticClass: "w-5 h-5",
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M6 18L18 6M6 6l12 12"
    }
  })])])]), _c('div', {}, [_c('div', {
    staticClass: "grid grid-cols-2 gap-6"
  }, [_c('div', [_c('FormLabel', {
    attrs: {
      "htmlFor": "vendor"
    }
  }, [_vm._v("Publisher")]), _c('div', {
    ref: "vendorDropdownContainer",
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "w-full px-3 py-1 border border-gray-300 rounded-md vendor-input bg-gray-50 cursor-text",
    on: {
      "click": function ($event) {
        _vm.showVendorDropdown = !_vm.showVendorDropdown;
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-wrap gap-2"
  }, [_vm._l(_vm.selectedVendors, function (vendor) {
    return _c('div', {
      key: vendor.id,
      staticClass: "flex items-center px-2 py-1 text-sm text-blue-800 bg-blue-100 rounded"
    }, [_vm._v(" " + _vm._s(vendor.name) + " "), _c('button', {
      staticClass: "ml-1 text-blue-600 hover:text-blue-800 focus:outline-none",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.removeVendor(vendor);
        }
      }
    }, [_c('svg', {
      staticClass: "w-3 h-3",
      attrs: {
        "fill": "none",
        "stroke": "currentColor",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        "d": "M6 18L18 6M6 6l12 12"
      }
    })])])]);
  }), _vm.selectedVendors.length === 0 ? _c('div', {
    staticClass: "py-1 text-gray-500 text-base"
  }, [_vm._v(" Select Publisher ")]) : _vm._e()], 2)]), _c('ChevronDownFilled', {
    attrs: {
      "className": "absolute w-3 h-3 text-gray-500 transform -translate-y-1/2 pointer-events-none right-3 top-1/2"
    }
  }), _vm.showVendorDropdown ? _c('div', {
    staticClass: "absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg vendor-dropdown"
  }, [_c('div', {
    staticClass: "p-2 border-b"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('SearchOutline', {
    attrs: {
      "className": "absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.vendorSearchTerm,
      expression: "vendorSearchTerm"
    }],
    staticClass: "w-full py-2 pr-3 border border-gray-300 rounded-md pl-9 focus:outline-none focus:ring-2 focus:ring-blue-500",
    attrs: {
      "type": "text",
      "placeholder": "Search Publisher"
    },
    domProps: {
      "value": _vm.vendorSearchTerm
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.vendorSearchTerm = $event.target.value;
      }, _vm.handleVendorSearch]
    }
  })], 1)]), _c('div', {
    staticClass: "overflow-y-auto vendor-list-container"
  }, _vm._l(_vm.vendorOptions, function (vendor) {
    return _c('div', {
      key: vendor.id,
      staticClass: "flex items-center px-3 py-2 cursor-pointer hover:bg-gray-50",
      on: {
        "click": function ($event) {
          return _vm.toggleVendor(vendor);
        }
      }
    }, [_c('input', {
      staticClass: "mr-2",
      attrs: {
        "type": "checkbox",
        "readonly": ""
      },
      domProps: {
        "checked": _vm.isVendorSelected(vendor)
      }
    }), _vm._v(" " + _vm._s(vendor.name) + " ")]);
  }), 0), _vm.isLoadingVendors ? _c('div', {
    staticClass: "p-3 text-center text-gray-500"
  }, [_vm._v(" Loading publishers... ")]) : _vm._e()]) : _vm._e()], 1)], 1), _c('div', [_c('FormLabel', {
    attrs: {
      "htmlFor": "role"
    }
  }, [_vm._v("Role")]), _c('SelectRadio', {
    attrs: {
      "id": "role",
      "defaultText": "Select Role",
      "options": _vm.roleOptions
    },
    model: {
      value: _vm.filters.role,
      callback: function ($$v) {
        _vm.$set(_vm.filters, "role", $$v);
      },
      expression: "filters.role"
    }
  })], 1), _c('div', [_c('FormLabel', {
    attrs: {
      "htmlFor": "group"
    }
  }, [_vm._v("Group Type")]), _c('SelectRadio', {
    attrs: {
      "id": "group",
      "defaultText": "Select Group Type",
      "options": _vm.groupOptions
    },
    model: {
      value: _vm.filters.group,
      callback: function ($$v) {
        _vm.$set(_vm.filters, "group", $$v);
      },
      expression: "filters.group"
    }
  })], 1), _c('div', [_c('FormLabel', {
    attrs: {
      "htmlFor": "status"
    }
  }, [_vm._v("Status")]), _c('SelectRadio', {
    attrs: {
      "id": "status",
      "defaultText": "Select Status",
      "options": _vm.statusOptions
    },
    model: {
      value: _vm.filters.status,
      callback: function ($$v) {
        _vm.$set(_vm.filters, "status", $$v);
      },
      expression: "filters.status"
    }
  })], 1)]), _c('div', {
    staticClass: "flex justify-start gap-3 mt-6"
  }, [_c('Button', {
    staticClass: "px-6 py-2",
    attrs: {
      "color": "primary",
      "size": "base"
    },
    on: {
      "click": _vm.onApplyFilter
    }
  }, [_vm._v(" Filter ")]), _c('Button', {
    staticClass: "px-6 py-2",
    attrs: {
      "color": "alternative",
      "variant": "outlined",
      "size": "base"
    },
    on: {
      "click": _vm.onReset
    }
  }, [_vm._v(" Reset ")])], 1)])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }